<div class="filterElement">
  <div class="checkbox">
    <input id="{{'checkboxFilter' + filterElementParameter.name}}" type="checkbox" name="isActive"
      [(ngModel)]="isActive" (change)="onIsActiveChange($event)" />
    <label for="{{'checkboxFilter' + filterElementParameter.name}}">
      {{filterElementParameter.name}}
    </label>
  </div>
</div>
<div *ngIf="isActive && filterElementParameter.type === FilterParameterType.text" @animation
  class="filterElementContent">
  <div class="form-group">
    <input type="text" name="textInput" [(ngModel)]="textValue" (keyup)="onTextValueChange($event)"
      placeholder="{{filterElementParameter.name}}" class="form-control" />
  </div>
</div>
<div *ngIf="isActive && filterElementParameter.type === FilterParameterType.select" @animation
  class="selectFilterElement">
  <div *ngFor="let value of filterElementParameter.availableValues" class="selectFilterElementContent">
    <div class="checkbox">
      <input id="{{'select' + value.key}}" type="checkbox" name="{{value.name}}" [checked]="setChecked(value)"
        (change)="onSelectedValueChange($event, value.key)" />
      <label for="{{'select' + value.key}}">
        {{value.name}}
      </label>
    </div>
  </div>
</div>
<div [@datesAnimation]="isActive && filterElementParameter.type === FilterParameterType.dateRange ? 'open' : 'closed'"
  class="filterElementContent">
  <div class="form-group">
    <div style="display: flex;">
      <input type="text" id="{{this.dateFromId}}" class="form-control datepicker" name="dateFrom" placeholder="From"
      [ngModel]="dateFrom" [disabled]="filterElementParameter.isOnlyDefaultValue"/>
      <div class="font-icon-container"><a><i class="fa fa-calendar-check-o"></i></a></div>
    </div>
    <div style="display: flex;">
      <input type="text" id="{{this.dateToId}}" class="form-control datepicker" name="dateTo" placeholder="To"
      [ngModel]="dateTo" [disabled]="filterElementParameter.isOnlyDefaultValue"/>
      <div class="font-icon-container"><a><i class="fa fa-calendar-check-o"></i></a></div>
    </div>
  </div>
</div>